import Fetcher from '../util/Fetcher';
import { newActiveQuiz } from '../actions/quizzes';
import { handleQuizResponse } from './callHandlers';
import { interactionTypeFetch } from './interactionTypes';
import { getQuizEntries } from '../../building/api/quizEntries';

// ==== CALLBACKS ====

export var quizFetchHandler = function quizFetchHandler(dispatch, quiz) {
  dispatch([handleQuizResponse(quiz), newActiveQuiz("".concat(quiz.id))]);
};

// ====================================
// fetch the data for an existing quiz
// and add it as the active quiz
// ====================================

export function getExistingQuiz(quizId) {
  var quizUrl = "/api/quizzes/".concat(quizId);
  return function (dispatch, getState) {
    var fetcher = new Fetcher();
    return fetcher.get(quizUrl).then(function (quizData) {
      return quizFetchHandler(dispatch, quizData);
    });
  };
}
export function getExistingQuizAndItems(quizId) {
  var quizUrl = "/api/quizzes/".concat(quizId);
  return function (dispatch, getState) {
    var fetcher = new Fetcher();
    return fetcher.get(quizUrl).then(function (quizData) {
      return quizFetchHandler(dispatch, quizData);
    }).then(function () {
      return dispatch(getQuizEntries(quizId));
    }).then(function () {
      return dispatch(interactionTypeFetch());
    });
  };
}